import "@story/story_assets/dom_extend";
import { Animation } from "@story/story_assets/animations";

function findButton() {
	return document.querySelector(".ai-btn");
}

function findWindow() {
	return document.querySelector(".ai-window");
}

function showAiChat(id) {
	const screens = document.querySelectorAll("[data-ai-chat-id]");
	let selectedScreen = null;

	for (const screen of screens) {
		if (screen.getAttribute("data-ai-chat-id") == id) {
			selectedScreen = screen;
			screen.classList.remove("d-none");
		} else {
			screen.classList.add("d-none");
		}
	}
}

function clearTransitions() {
	const screens = document.querySelectorAll("[data-ai-chat-id]");
	for (const screen of screens) {
		screen.classList.remove("ai-chat-transition-forward-in");
		screen.classList.remove("ai-chat-transition-forward-out");
		screen.classList.remove("ai-chat-transition-backward-in");
		screen.classList.remove("ai-chat-transition-backward-out");
	}
}

function transitionForward(screenId) {
	clearTransitions();

	const screens = document.querySelectorAll("[data-ai-chat-id]");
	for (const screen of screens) {
		if (screen.getAttribute("data-ai-chat-id") == screenId) {
			screen.classList.remove("d-none");
			screen.classList.add("ai-chat-transition-forward-in");
		} else {
			screen.classList.add("ai-chat-transition-forward-out");
		}
	}
}

function transitionBackward(screenId) {
	clearTransitions();

	const screens = document.querySelectorAll("[data-ai-chat-id]");
	for (const screen of screens) {
		if (screen.getAttribute("data-ai-chat-id") == screenId) {
			screen.classList.remove("d-none");
			screen.classList.add("ai-chat-transition-backward-in");
		} else {
			screen.classList.add("ai-chat-transition-backward-out");
		}
	}
}


document.addEventSelectorListener("click", "[data-ai-chat-window='open']", async (event, target) => {
	event.preventDefault();

	// Temporary fix: Clear the transition classes. This will prevent old state of the chat window.
	clearTransitions();

	const button = findButton();
	const window = findWindow();

	await Animation.fadeOut(button);
	Animation.fadeIn(window);
});

document.addEventSelectorListener("click", "[data-ai-chat-window='close']", async (event, target) => {
	event.preventDefault();

	const button = findButton();
	const window = findWindow();

	await Animation.fadeOut(window);
	Animation.fadeIn(button);
});

document.addEventSelectorListener("click", "[data-ai-chat-forward]", async (event, target) => {
	event.preventDefault();
	const id = target.getAttribute("data-ai-chat-forward");
	transitionForward(id);
	// showAiChat(id);
});

document.addEventSelectorListener("click", "[data-ai-chat-backward]", async (event, target) => {
	event.preventDefault();
	const id = target.getAttribute("data-ai-chat-backward");
	transitionBackward(id);
});
